export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "breadcrumbs": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Breadcrumbs"])}
      },
      "fr": {
        "breadcrumbs": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fil d'ariane"])}
      }
    }
  })
}
